import { ProgramContent, ProgramMetadata } from "@domain/program/program";
import { ProgramManager } from "@domain/program/program-manager";
import { TemplateOperation } from "@domain/template/template";
import { TemplateManager } from "@domain/template/template-manager";
import { observable } from "micro-observables";

export class TemplateOperationsManager {
	private readonly _lastTemplateOperation = observable<TemplateOperation | null>(null);

	lastTemplateOperation = this._lastTemplateOperation.readOnly();

	constructor(
		private readonly templateManager: TemplateManager,
		private readonly programManager: ProgramManager,
	) {}

	async performDeleteOperation(templateId: string, templateName: string): Promise<void> {
		await this.templateManager.deleteTemplate(templateId);
		this._lastTemplateOperation.set({ type: "delete", templateName });
	}

	async performAssignOperation(patientId: string, programContent: ProgramContent): Promise<ProgramMetadata> {
		const metadata = await this.programManager.createDraftProgram(patientId, programContent);
		this._lastTemplateOperation.set({ type: "assign" });
		return metadata;
	}

	removeLastTemplateOperation(): void {
		this._lastTemplateOperation.set(null);
	}

	async reset(): Promise<void> {
		this.removeLastTemplateOperation();
	}
}
